// Merkt den zuletzt gewählten Reiter des mobilen Hinzufügen-Modus geräteweit in localStorage.
// Jeder Zugriff steht in try/catch: im privaten Modus oder bei blockiertem Speicher verhält
// sich der Modus wie beim ersten Öffnen (Suche).
const STORAGE_KEY = 'mobileAddTab';
const TABS = ['search', 'suggestions'];

export function readAddTab() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return TABS.includes(value) ? value : 'search';
  } catch {
    return 'search';
  }
}

export function writeAddTab(value) {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Speicher blockiert: der Reiter gilt nur für diese Sitzung.
  }
}
